module.exports = __webpack_public_path__ + "media/icons/mail-1da8850c.png";